/**
 * Created by r4zi4l on 21.06.2021
 */

const VIPRewardedWindow = CleverappsWindow.extend({
    onWindowLoaded: function (onReward) {
        this.onReward = onReward;

        this.isVertical = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL;

        const levelData = cleverapps.dataLoader.load(DataLoader.TYPES.VIP_LEVEL) || { l: 0, t: 0 };
        this.level = Math.max(levelData.l - Math.floor(Math.max(Date.now() - levelData.t, 0) / VIPRewardedWindow.LEVEL_INTERVAL), 0);

        this._super({
            name: "VIPRewardedWindow",
            title: Messages.get("VIPRewardedWindow.title"),
            content: this.createContent(),
            noBackground: true,
            notCloseByTouchInShadow: true
        });

        cleverapps.focusManager.showControlsWhileFocused("MenuBarGoldItem");
    },

    getPerson: function () {
        return {
            role: cleverapps.persons.choose("king", "hero").role,
            emotion: "happy"
        };
    },

    skip: function (price) {
        if (cleverapps.user.spendHard(cleverapps.EVENTS.SPENT.SKIP_VIP, price)) {
            if (this.onReward) {
                this.onReward();
            }
            this.incLevel();
            this.onReward = undefined;
            this.close();
        }
    },

    incLevel: function () {
        cleverapps.dataLoader.save(DataLoader.TYPES.VIP_LEVEL, {
            l: this.level + 1,
            t: Date.now()
        });
    },

    createContent: function () {
        const styles = cleverapps.styles.VIPRewardedWindow;

        const animationNode = new cc.Node();
        animationNode.setAnchorPoint(0.5, 0.5);
        animationNode.setContentSize2(styles.animation);
        const icon = new cleverapps.Spine(bundles.vip_window.jsons.vip_icon_json);

        icon.setStartListener(() => {
            cleverapps.effects.fire("vip_window.ads.slapstick");
        });

        icon.setCompleteListener(() => {
            icon.setAnimation(0, "animation");
        });

        icon.setAnimation(0, "animation");
        animationNode.addChild(icon);
        icon.setAlignment(animationNode.width / 2, animationNode.height / 2);

        const description = cleverapps.UI.generateOnlyText(Messages.get("VIPRewardedWindow.description"), cleverapps.styles.FONTS.VIPREWARDEDWINDOW_DESCRIPTION_TEXT);
        description.setDimensions(this.isVertical ? styles.description.verticalWidth : styles.description.width, 0);
        description.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        const progress = this.createProgress();

        const cancelButton = new cleverapps.UI.Button({
            width: styles.button.width,
            height: styles.button.height,
            text: Messages.get("Cancel"),
            onClicked: this.close.bind(this),
            type: cleverapps.styles.UI.Button.Images.button_red
        });

        const skipPrice = this.calcPrice();

        const skipButton = new cleverapps.UI.Button({
            width: styles.button.width,
            height: styles.button.height,
            text: `${Messages.get("Skip")}$$${skipPrice}`,
            onClicked: this.skip.bind(this, skipPrice),
            type: cleverapps.styles.UI.Button.Images.button_green
        });

        if (!cleverapps.user.canTakeHard(skipPrice)) {
            skipButton.disable();
        }

        const buttons = new cleverapps.Layout([skipButton, cancelButton], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.button.margin
        });

        const vipPeriod = cleverapps.vipAdsAdapter.getVIPStatus().end;

        let remainingDays = Math.ceil((vipPeriod - Date.now()) / cleverapps.parseInterval("1 day"));
        if (remainingDays > 30) {
            remainingDays = 30;
        }

        const note = cleverapps.UI.generateOnlyText(Messages.get("VIPRewardedWindow.note", {
            price: cleverapps.vipAdsAdapter.calculateMinimalVipSum(),
            remaining: remainingDays
        }), cleverapps.styles.FONTS.VIPREWARDEDWINDOW_NOTE_TEXT);
        note.setOpacity(200);
        note.setDimensions(this.isVertical ? styles.note.verticalWidth : styles.note.width, 0);
        note.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        const content = new cleverapps.Layout([animationNode, description, progress, buttons, note], {
            direction: cleverapps.UI.VERTICAL,
            padding: styles.padding,
            margin: this.isVertical ? styles.verticalMargin : styles.margin
        });
        content.y += 200;
        return content;
    },

    onClose: function () {
        this.onReward = undefined;
    },

    calcDuration: function () {
        return VIPRewardedWindow.BASE_DURATION + VIPRewardedWindow.LEVEL_DURATION * this.level;
    },

    calcPrice: function () {
        return Math.round(this.calcDuration() / cleverapps.parseInterval("1 second") * (["merge", "merge2"].includes(cleverapps.config.type) ? VIPRewardedWindow.SKIP_SECOND_PRICE : VIPRewardedWindow.SKIP_WHEN_NO_SOFT_SECOND_PRICE));
    },

    createProgress: function () {
        const styles = cleverapps.styles.VIPRewardedWindow.progress;

        const progress = new ScaledProgressBar({
            background: bundles.progress_bar.frames.bg_vip,
            progress: bundles.progress_bar.frames.bar_vip
        });
        progress.setLength(styles.width);
        progress.setPercentage(10);

        const duration = this.calcDuration();
        progress.runAction(new ScaledProgressBarProgressTo(duration / 1000, 100));
        let soundTics = 0;
        const countdown = new cleverapps.CountDown(duration, {
            onTick: function () {
                cleverapps.effects.fire(soundTics % 2 === 0 ? "vip_window.ads.timer.1" : "vip_window.ads.timer.2");
                soundTics++;
            },
            onFinish: function () {
                if (this.onReward) {
                    this.onReward();
                }
                this.incLevel();
                cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STATS.VIP_REWARDED_DAU);
                cleverapps.playSession.logEvent(cleverapps.EVENTS.STATS.VIP_REWARDED_WATCHED);
                this.onReward = undefined;
                if (!this.closed) {
                    this.close();
                }
            }.bind(this)
        });

        const timer = new cleverapps.CountDownView(countdown, {
            font: cleverapps.styles.FONTS.VIPREWARDEDWINDOW_TIMER_TEXT
        });
        timer.setAlignment(styles.timer);
        progress.addChild(timer);

        return progress;
    },

    listBundles: function () {
        return ["vip_window"];
    }
});

VIPRewardedWindow.BASE_DURATION = cleverapps.parseInterval("12 seconds");
VIPRewardedWindow.LEVEL_DURATION = cleverapps.parseInterval("2 seconds");
VIPRewardedWindow.SKIP_SECOND_PRICE = 1 / 7;
VIPRewardedWindow.SKIP_WHEN_NO_SOFT_SECOND_PRICE = 15 / 12;
VIPRewardedWindow.LEVEL_INTERVAL = cleverapps.parseInterval("300 seconds");

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    VIPREWARDEDWINDOW_DESCRIPTION_TEXT: {
        size: 42
    },

    VIPREWARDEDWINDOW_TIMER_TEXT: {
        size: 60
    },

    VIPREWARDEDWINDOW_NOTE_TEXT: {
        size: 22
    }
});

cleverapps.styles.VIPRewardedWindow = {
    margin: 40,
    verticalMargin: 80,

    padding: {
        top: 60
    },

    animation: {
        width: 300,
        height: 300
    },

    description: {
        width: 1000,
        verticalWidth: 800
    },

    progress: {
        width: 600,

        timer: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 2 }
        }
    },

    button: {
        width: 300,
        height: 100,
        margin: 80
    },

    note: {
        width: 1000,
        verticalWidth: 800
    }
};
